// src/utils/datetime.js
// Centralized dayjs instance configured as a near drop-in for the moment /
// moment-timezone APIs the app relied on. Importing dayjs from here guarantees
// the required plugins are registered exactly once.
//
// Why dayjs: moment-timezone shipped ~40kB gzip (730kB raw) into the bundle.
// dayjs core is ~3kB gzip; the plugins below add only what we actually use.
//
// Supported moment APIs in the codebase (all covered here):
//   moment(), moment(date), moment(str, "YYYY-MM-DD")  → customParseFormat
//   .format("Do" / "z" / "Z")                          → advancedFormat
//   .fromNow() / .fromNow(true)                         → relativeTime
//   moment.tz(zone) / .tz(zone)                         → utc + timezone
//   .startOf/.endOf/.add/.subtract/.isSame/.isAfter/.date(n)/.toDate() → core
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

export default dayjs;
